import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
// import { ResizedEvent } from 'angular-resize-event';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EnvironmentService } from '../services/services/environmet.service';
import { AmplitudeService } from '../services/services/amplitude.service';
import { ResizedEvent } from 'angular-resize-event-package';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements AfterViewInit {
  title = 'pcc-admin';
  menuUrl = '';
  topbarUrl = '';
  menuItems = '';
  userInfo = '';
  topbarHeight = 0;
  isOneIdentity = EnvironmentService.isOneIdentity && EnvironmentService.environment.topMenuUrl;
  @ViewChild("topbarWrapper") topbarWrapper: ElementRef<HTMLElement>;
  constructor(private http: HttpClient, private router: Router, private titleService: Title, private activatedRoute: ActivatedRoute, @Inject(DOCUMENT) private document: Document, private amplitudeService: AmplitudeService) {
    this.amplitudeService.init(environment['amplitudeApiKey']);
    let page = "home";
    let second = "Index";
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(event => {
      event = event as NavigationEnd;
      const urlSplit = event.url.split('/');
      page = event.url === '/' ? page : urlSplit[1];

      this.http.get<any>(`${EnvironmentService.environment.baseApiUrl}/admin/GetMainMenuSelectedFiltered/${page}`).subscribe(result => {
        this.menuItems = JSON.stringify(result)
      });

      this.http.get<any>(`${EnvironmentService.environment.baseApiUrl}/admin/GetUserInformation/`).subscribe(result => {
        this.userInfo = JSON.stringify(result)
      });

      const rt = this.getChild(this.activatedRoute);
      rt.data.subscribe(data => {
        this.titleService.setTitle(data.title || 'Puzzel Admin');
        this.amplitudeService.trackPageView();
      });

    });

    this.menuUrl = `${EnvironmentService.environment.menuComponentUrl}?v=${environment.version}`;
    this.topbarUrl = EnvironmentService.environment.topMenuUrl;
  }

  getChild(activatedRoute: ActivatedRoute) {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }

  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.topbarHeight = this.topbarWrapper?.nativeElement.clientHeight ?? 0;
      this.setMenuPosition();
    }, 500)
  }

  onTopBarResized(event: ResizedEvent) {
    this.topbarHeight = event.newRect.height;
    this.setMenuPosition();
  }

  setMenuPosition() {
    let sidenav: HTMLElement = this.document.querySelector(".leftWrapper .sidenav");
    let submenu: HTMLElement = this.document.querySelector(".leftWrapper .submenu");
    if (sidenav) {
      sidenav.style.marginTop = this.topbarHeight + 'px';
      sidenav.style.height = 'calc(100% - ' + this.topbarHeight + 'px)';
    }
    if (submenu) {
      submenu.style.marginTop = this.topbarHeight + 'px';
      submenu.style.height = 'calc(100% - ' + this.topbarHeight + 'px)';
    }
  }

  logout() {
    this.amplitudeService.reset();
    window.localStorage.removeItem("puzzel_refreshToken");
    window.localStorage.removeItem("puzzel_token");
    window.location.href = EnvironmentService.environment.baseUrl + "/account/LogOut";
  }

  userSwitched($event) {
    if ($event?.detail?.solutionId && $event?.detail?.solutionUserId) {
      window.location.href = EnvironmentService.environment.baseUrl + "/account/SwitchUser?sluid=" + encodeURIComponent(`${$event.detail.solutionId}:${$event.detail.solutionUserId}`);
    } else {
      console.warn("on-user-switch:details don't contains needed data!");
    }
  }

}
